import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/uece-white.svg'
import _imports_1 from '@/assets/images/mcti-white.svg'
import _imports_2 from '@/assets/images/softex-white.svg'
import _imports_3 from '@/assets/images/irede-white.svg'


const _hoisted_1 = { class: "w-full bg-h-primary-800 px-8" }
const _hoisted_2 = { class: "grid grid-cols-12 md:p-8 py-8 gap-y-10 gap-3" }
const _hoisted_3 = { class: "col-span-12 sm:col-span-12 lg:col-span-6 xl:col-span-6 text-center md:text-start" }
const _hoisted_4 = { class: "text-white font-bold" }
const _hoisted_5 = { class: "text-white text-[12px]" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"col-span-12 sm:col-span-12 lg:col-span-6 xl:col-span-6 flex justify-around px-4 mt-2 gap-8 md:gap-3 scale-[0.6] md:scale-100 w-100 h-6 sm:h-6 lg:h-6 xl:h-10\"><img src=\"" + _imports_0 + "\" alt=\"uece\"><img src=\"" + _imports_1 + "\" alt=\"mcti\"><img src=\"" + _imports_2 + "\" alt=\"softex\"><img src=\"" + _imports_3 + "\" alt=\"irede\"></div>", 1)
const _hoisted_7 = { class: "flex w-full justify-center items-center mt-14 lg:mt-10" }
const _hoisted_8 = { class: "text-white py-5 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Sistema Homero",
                en: "Homero System",
              })), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Plataforma de educação adaptativa, com uso de inteligência artificial, na qual os alunos capacitam-se, conforme a sua disponibilidade e condições de aprendizado.",
                en: "Adaptive education platform, using artificial intelligence, in which students are trained, according to their availability and learning conditions.",
              })), 1)
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, " © " + _toDisplayString(_ctx.todayYear) + ". " + _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Todos os direitos reservados.",
              en: "All rights reserved.",
            })), 1)
      ])
    ])
  ]))
}